import { format } from 'date-fns';
import fr from 'date-fns/locale/fr';

const parseUtcDateTimeWithoutZone = (dateTime: string): Date => {
  const trimmed = dateTime.trim();
  const normalized = trimmed.includes('T')
    ? trimmed
    : trimmed.replace(' ', 'T');
  if (/[zZ]|[+-]\d{2}:?\d{2}$/.test(normalized)) {
    return new Date(normalized);
  }
  return new Date(`${normalized}Z`);
};

export const formatNewsletterScheduledAt = (dateTime: string): string =>
  new Intl.DateTimeFormat(undefined, {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
    timeZoneName: 'short',
  }).format(parseUtcDateTimeWithoutZone(dateTime));

export const formatDate = (
  date: number | Date | string | undefined,
  dateFormat: string,
) => {
  if (!date) return undefined;
  if (typeof date === 'string') {
    // eslint-disable-next-line no-param-reassign
    date = new Date(date);
  }
  return format(date, dateFormat, { locale: fr });
};
